import { render, staticRenderFns } from "./verici_transaction.vue?vue&type=template&id=4bf8c989&"
import script from "./verici_transaction.vue?vue&type=script&lang=js&"
export * from "./verici_transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports